import { render, staticRenderFns } from "./warehouse-configure.vue?vue&type=template&id=739733c2&"
import script from "./warehouse-configure.js?vue&type=script&lang=js&"
export * from "./warehouse-configure.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports